/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const aiAnalysisRuns = sqliteTable('ai_analysis_runs', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  encounter_id: text('encounter_id'),
  feature: text('feature'),
  provider: text('provider'),
  provider_mode: text('provider_mode'),
  model_version: text('model_version'),
  status: text('status'),
  images_submitted: integer('images_submitted'),
  aggregation: text('aggregation'),
  primary_diagnosis: text('primary_diagnosis'),
  confidence: real('confidence'),
  severity: text('severity'),
  agreement: real('agreement'),
  symptoms_json: text('symptoms_json'),
  treatment_json: text('treatment_json'),
  top_predictions_json: text('top_predictions_json'),
  per_image_results_json: text('per_image_results_json'),
  embedding_shape_json: text('embedding_shape_json'),
  disclaimer: text('disclaimer'),
  requested_by: text('requested_by'),
  requested_at: text('requested_at'),
  completed_at: text('completed_at'),
  error_message: text('error_message'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
